import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridItemWiseView from './DataGridItemWiseView';
import { Container } from 'reactstrap';

const UATItemGrid = () => {
    if (localStorage.getItem("usertype") !== "Backend User") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Item Grid - UAT" title="Item Grid - UAT" mainTitle="Item Grid - UAT" />
                <Container fluid={true}>
                    <DataGridItemWiseView source="uat" />
                </Container>
            </Fragment>
        </UL>
    )
}

export default UATItemGrid
